import React, { useContext } from 'react';
import { SideNavigation, TopButton } from '../components';
import { SideNavContext } from '../contexts';
import Header from '../components/header/Header';
import PortfolioDetail from '../components/portfolio/PortfolioDetail';
import Footer from '../components/footer/Footer';

const PortfolioDetailPage = () => {

    const { isSideNavOpen } = useContext(SideNavContext);

    return (
        <>
            {isSideNavOpen && <SideNavigation />}

            <Header />

            <main>
                <PortfolioDetail />
            </main>

            <Footer />

            <TopButton />
        </>
    );
};

export default PortfolioDetailPage;